import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandToUpdate } from "../types";

export const updateBrand = async (
  brandId: string,
  brand: BrandToUpdate,
): Promise<void> => {
  const brandDocRef = doc(db, "brands", brandId);

  try {
    await updateDoc(brandDocRef, {
      ...brand,
    });

    await getDoc(brandDocRef);
  } catch (error) {
    console.error("Failed to update the brand:", error);
    throw error;
  }
};
